module.exports = __webpack_public_path__ + "img/remark_07.c8746747.svg";